import React from 'react';
import useGameStore from '@store/useGameStore';
import EffectIcon from '@components/ui/icons/EffectIcon';
import './EffectBar.css';

/**
 * EffectBar Component
 * Displays all active effects for a unit as a row of icons
 * Used in UnitInfoPanel under the unit name
 * 
 * @param {number} unitId - The unit ID to show effects for
 * @param {string} className - Additional CSS classes
 */
export default function EffectBar({ unitId, className = '' }) {
  // Get unit from store (use getState to avoid subscription)
  const unit = useGameStore.getState().getUnitOrAvailableUnitById(unitId);
  
  if (!unit) {
    console.warn('[EffectBar] Unit not found for ID:', unitId);
    return <div className={`effect-bar empty ${className}`} />;
  }
  
  // Get active effects
  const activeEffects = unit.active_effects?.filter(effect => effect.is_active) || [];
  
  // If no effects, return empty placeholder to maintain layout
  if (activeEffects.length === 0) {
    return <div className={`effect-bar empty ${className}`} />;
  }
  
  return (
    <div className={`effect-bar ${className}`}>
      {activeEffects.map(effect => (
        <EffectIcon
          key={effect.id}
          effectId={effect.effect_id}
          activeEffect={effect}  // Pass the full effect object for popup data
          variant="icon"
          className="effect-bar-icon"
        />
      ))}
    </div>
  );
}